import { graphql } from 'react-relay';

export const indisRefundHistoryIdQuery = graphql`
  query refundHistoryIdQuery {
    getRefundHistoryId {
      result
      refundHistoryId
      errors {
        code
        message
      }
    }
  }
`;
